module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M08-clean-9dd95325596f1b72dc998399ed768478.png";